import { Injectable } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { IRouterData } from '@classifieds-sell/state';

const URL_PATH_TERMINATOR_REGEX = /\?|\(/;

const SEARCH_URL_SUFFIXES = ['search', 'refine'];

const LISTING_URL_IDENTIFIER = 'listing';
const LISTING_URL_IDENTIFIER_CANONICAL_PATH_END_OFFSET = 2;

@Injectable()
export class RouterService {
    public extractUrl(fullUrl: string): string {
        return fullUrl;
    }

    public extractCanonicalPath(url: string): string {
        const segments = url.split('/');
        const canonicalPathSegments = this.getCanonicalPathSegments(segments);

        return canonicalPathSegments.join('/');
    }

    private getCanonicalPathSegments(segments: Array<string>): Array<string> {
        const listingIdentifierIndex = segments.indexOf(LISTING_URL_IDENTIFIER);
        if (listingIdentifierIndex !== -1) {
            return segments.slice(
                0,
                listingIdentifierIndex +
                    LISTING_URL_IDENTIFIER_CANONICAL_PATH_END_OFFSET
            );
        }

        const searchSuffixIndex = segments.findIndex((segment) =>
            SEARCH_URL_SUFFIXES.includes(segment)
        );
        if (searchSuffixIndex !== -1) {
            return segments.slice(0, searchSuffixIndex);
        }

        return segments;
    }

    public paramsAreEqual(paramsA: Params, paramsB: Params): boolean {
        const aKeys = Object.keys(paramsA);
        const bKeys = Object.keys(paramsB);
        return (
            aKeys.length === bKeys.length &&
            !aKeys.find((key) => paramsA[key] !== paramsB[key])
        );
    }

    public extractRouteMetaData(route: ActivatedRoute): {
        params: Params;
        data: IRouterData;
    } {
        let params = {};
        let data = {};

        while (route) {
            const { snapshot } = route;

            params = {
                ...params,
                ...snapshot.params
            };
            data = {
                ...data,
                ...snapshot.data,
                subCategory: (<any>params).subCategory
            };
            route = route.firstChild;
        }

        return {
            params,
            data
        };
    }
}
